import { Routes } from '@angular/router';
import { AppComponent } from './app.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'game', pathMatch: 'full' },
      { path: 'game', component: AppComponent },
    ],
  },
  { path: '**', redirectTo: 'game' },
];
